import {
  Avatar,
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { CURRENCY } from "../../../../constants/Variables";
import {
  calculateProductFinalPrice,
  handleOpenSnackBar,
  roundTo2Decimal,
} from "../../../../utils";
import GlobalButton from "../../../../components/CustomButton";
import { getSupplierSingleProductById } from "../../../../services/supplier/productApiFn";
import { useSelector } from "react-redux";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(2),
  },
  "& .MuiPaper-root": {
    width: "520px",
    maxWidth: "95vw",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));

const VariantsDialog = forwardRef(({ onConfirm }, ref) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [dialogData, setDialogData] = useState({});
  const [productDetail, setProductDetail] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  // Redux state
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      setOpen(true);
      setDialogData(params);
    },
    closeDialog() {
      handleClose();
    },
  }));

  const handleClose = () => {
    setOpen(false);
    setDialogData({});
    setProductDetail({});
    setIsLoading(true);
  };

  const fetchchedProductDetail = async (id) => {
    try {
      const response = await getSupplierSingleProductById(id);
      if (response?.data?.status === "success") {
        const data = response?.data?.data;
        setProductDetail(data);
      } else {
        handleOpenSnackBar(response?.data?.message, "error");
      }
    } catch (error) {
      handleOpenSnackBar(error?.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (dialogData?.row?._id) {
      fetchchedProductDetail(dialogData?.row?._id);
    }
  }, [dialogData?.row?._id]);

  const renderLoading = () => {
    return (
      <Stack minHeight={200} justifyContent="center" alignItems="center">
        <CircularProgress />
      </Stack>
    );
  };

  console.log(productDetail, "productDetail");

  const renderVariants = () => {
    return (
      <Stack spacing={1.5}>
        {productDetail?.variants?.length > 0 ? (
          productDetail.variants.map((variant, index) => {
            const finalPrice = roundTo2Decimal(
              calculateProductFinalPrice(
                variant.price,
                variant.discount,
                variant.profitMargin,
              ),
            );
            const attributes = variant.attributes
              ? Object.entries(variant.attributes).map(([key, attr]) => ({
                  key,
                  label: attr?.label ?? key,
                  value: attr?.value,
                }))
              : [];

            console.log(attributes, "sdasdadsadsadsadasdsadsad");
            return (
              <Box key={variant._id || index}>
                {index > 0 && <Divider sx={{ my: 1.5 }} />}
                <Stack direction="row" spacing={2} alignItems="flex-start">
                  <Avatar
                    src={variant.images?.[0]}
                    variant="rounded"
                    sx={{
                      width: 56,
                      height: 56,
                      bgcolor: "grey.200",
                    }}
                  />
                  <Stack spacing={0.5} sx={{ flex: 1, minWidth: 0 }}>
                    {attributes.length > 0 && (
                      <Stack direction="row" flexWrap="wrap" gap={0.5}>
                        {attributes.map(({ key, label, value }) => {
                          const attributeLabel =
                            productDetail?.variantAttributes?.find(
                              (attr) => attr.value === key,
                            )?.label;
                          return (
                            <Typography key={key} variant="body2">
                              <Typography
                                component="span"
                                color="text.secondary"
                                variant="caption"
                              >
                                {attributeLabel[currentLanguage] ||
                                  attributeLabel}
                                :
                              </Typography>{" "}
                              {typeof value === "string" &&
                              value.startsWith("#") ? (
                                <Stack
                                  component="span"
                                  direction="row"
                                  alignItems="center"
                                  gap={0.5}
                                  display="inline-flex"
                                >
                                  <Box
                                    component="span"
                                    sx={{
                                      width: 14,
                                      height: 14,
                                      borderRadius: "4px",
                                      bgcolor: value,
                                      border: "1px solid",
                                      borderColor: "divider",
                                    }}
                                  />
                                  {variant.attributes?.[key]?.label[
                                    currentLanguage
                                  ] ??
                                    variant.attributes?.[key]?.label ??
                                    value}
                                </Stack>
                              ) : (
                                (variant.attributes?.[key]?.label[
                                  currentLanguage
                                ] ??
                                variant.attributes?.[key]?.label ??
                                value)
                              )}
                            </Typography>
                          );
                        })}
                      </Stack>
                    )}
                    <Typography variant="caption" color="text.secondary">
                      SKU: {variant.sku || "—"}
                    </Typography>
                    <Stack
                      direction="row"
                      flexWrap="wrap"
                      gap={1.5}
                      sx={{ pt: 0.5 }}
                    >
                      <Typography variant="body2">
                        {t("common.purchasePriceWithoutVat")}:{" "}
                        {roundTo2Decimal(variant.price ?? 0)} {CURRENCY}
                      </Typography>
                      <Typography variant="body2">
                        {t("common.profitMargin")}: {variant.profitMargin ?? 0}%
                      </Typography>
                      <Typography variant="body2">
                        {t("common.discount")}:{" "}
                        {roundTo2Decimal(variant.discount ?? 0)} {CURRENCY}
                      </Typography>
                      <Typography variant="body2" fontWeight={600}>
                        {t("common.finalPrice")}: {finalPrice} {CURRENCY}
                      </Typography>
                      <Typography variant="body2">
                        {t("common.quantity")}: {variant.quantity ?? 0}
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Box>
            );
          })
        ) : (
          <Typography
            color="text.secondary"
            variant="body2"
            textAlign="center"
            py={2}
          >
            {t("common.notAddedYet")}
          </Typography>
        )}
      </Stack>
    );
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="client-block-dialog-title"
      open={open}
    >
      <DialogTitle
        sx={{ m: 0, p: 2, textAlign: "center" }}
        id="client-block-dialog-title"
      >
        {t("common.variants")}
      </DialogTitle>
      <DialogContent dividers>
        {isLoading ? renderLoading() : renderVariants()}
      </DialogContent>
      <DialogActions>
        <GlobalButton
          variant="outlined"
          btnText={t("common.close")}
          handleClickBtn={handleClose}
          styleProps={{
            height: 45,
          }}
        />
      </DialogActions>
    </BootstrapDialog>
  );
});

export default VariantsDialog;
